<ap-modal #baseModal
          [appModalId]="'create-options'"
          [ariaLabel]="'Create Disclosure'"
          [title]="'Create Disclosure'"
          [closable]="true"
          [style]="{'width': '75rem'}"
          (onClose)="closeModalOk('create-options')">
  <div class="create-options-modal-body">
    @if (true) {
<div>
      <div class="flex-container">
        @for (option of options; track $index) {
<div>
          <ap-button [compact]="true" [label]="option.FORMNAME" class="ap-mr-spacing-3" [btnType]="'secondary'" (onClick)="onSelect(option)">
          </ap-button>
        </div>
}
      </div>
    </div>
}
    @if (false) {
<div class="viewport-wrapper">
      <dst-create-disclosure-template-viewport [rowObject]="rowObject"></dst-create-disclosure-template-viewport>
    </div>
}
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'text'" [label]="'CLOSE'" (onClick)="closeModalOk('copy-replicate')"></ap-button>
  </ng-template>
</ap-modal>
